import { Box, MenuItem, Paper, TextField, Typography } from '@mui/material';

import type { LlmCostTabOption } from '@/lib/types/dashboard/llmCost';

import { formatTab } from './format';

export interface LlmCostFilterValue {
  startDate: string;
  endDate: string;
  accountCode: string;
  tabId: string;
  status: string;
}

interface Props {
  value: LlmCostFilterValue;
  accountOptions: string[];
  tabOptions: LlmCostTabOption[];
  onChange: (next: LlmCostFilterValue) => void;
}

/** 期間 / account / tab / status のフィルタバー */
export function LlmCostFilterBar({ value, accountOptions, tabOptions, onChange }: Props) {
  // tab 候補は選択中 account に絞る（未選択なら全 tab）。
  const tabs = tabOptions.filter((t) => !value.accountCode || t.accountCode === value.accountCode);
  const update = (patch: Partial<LlmCostFilterValue>) => onChange({ ...value, ...patch });

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
        <TextField
          type="date"
          size="small"
          label="開始日"
          value={value.startDate}
          onChange={(e) => update({ startDate: e.target.value })}
          slotProps={{ inputLabel: { shrink: true } }}
        />
        <Typography>〜</Typography>
        <TextField
          type="date"
          size="small"
          label="終了日"
          value={value.endDate}
          onChange={(e) => update({ endDate: e.target.value })}
          slotProps={{ inputLabel: { shrink: true } }}
        />
        <TextField
          select
          size="small"
          label="アカウント"
          value={value.accountCode}
          // account を変えると tab 候補が変わるため tab をリセットする。
          onChange={(e) => update({ accountCode: e.target.value, tabId: '' })}
          sx={{ minWidth: 180 }}
        >
          <MenuItem value="">すべて</MenuItem>
          {accountOptions.map((code) => (
            <MenuItem key={code} value={code}>
              {code}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          select
          size="small"
          label="タブ"
          value={value.tabId}
          onChange={(e) => update({ tabId: e.target.value })}
          sx={{ minWidth: 180 }}
        >
          <MenuItem value="">すべて</MenuItem>
          {tabs.map((t) => (
            <MenuItem key={`${t.accountCode}/${t.tabId}`} value={t.tabId}>
              {value.accountCode
                ? formatTab(t.tabId, t.tabName)
                : `${t.accountCode} / ${formatTab(t.tabId, t.tabName)}`}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          select
          size="small"
          label="結果"
          value={value.status}
          onChange={(e) => update({ status: e.target.value })}
          sx={{ minWidth: 120 }}
        >
          <MenuItem value="">すべて</MenuItem>
          <MenuItem value="succeeded">成功</MenuItem>
          <MenuItem value="failed">失敗</MenuItem>
        </TextField>
      </Box>
    </Paper>
  );
}
